import SingleReactHookFormWrapper from "Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper";
import PersianSupportTextField from "Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField";
import i18next from "i18next";
import React from "react";
import { ArabicToPersian } from "utils/ConvertToPersianTextFromArabic";

const Words = (props) => {
  return (
    <React.Fragment>
      <div
        onWheel={props.listHandlers[1]}
        onTouchMove={props.listHandlers[2]}
        style={{ all: "inherit", marginTop: "0" }}
      >
        {props.listHandlers[0].length > 0 &&
          props.listHandlers[0].map((field, index) => (
            <SingleReactHookFormWrapper
              control={props.control}
              errors={props.formState.errors}
              key={field.id}
              name={`words[${index}].Value`}
              element={
                <PersianSupportTextField
                  label={ArabicToPersian(field.Value || field.Key)}
                  isSmall={true}
                  isEnglish={i18next.language === "en"}
                />
              }
            />
          ))}
      </div>
    </React.Fragment>
  );
};

export default Words;
